import React from 'react';

import {
  TWITTER_URL,
  FACEBOOK_URL,
} from '../constants';

import './SocialButtons.css';

export default () => (
  <div className="social-buttons">
    <a className="twitter-btn" href={TWITTER_URL} target="_blank" rel="noopener noreferrer">Tweet</a>
    <a className="facebook-btn" href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">Share</a>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/SocialButtons.js